export const survey = {
  contents: [
    '### Customer Experience Feedback',
    'We value your feedback! Please take a few minutes to let us know about your experience navigating the background investigation process and what improvements could be made. Thank you!',
    '',
  ],
  submissionContents: [
    '### Your form has been submitted successfully',
    '',
    '### Customer Experience Feedback',
    'We value your feedback! Please take a few minutes to let us know about your experience navigating the background investigation process and what improvements could be made. Thank you!',
    '',
    'Otherwise, press close below and you will be able to download an archival PDF of your submitted form for your records on this page.',
    '',
  ],
  link: { text: 'Take The Survey' },
  button: { text: 'Take The Survey' },
};
